import cellmaflexLogo from "../../../../assets/images/CellmaflexIcon.png";
import { cellmaflexUrl } from "../../../../api/AxiosAPICall";
import cellmalogo from "../../../../assets/images/cellmaflex_logo1.png";
import { Box, Typography } from "@mui/material";
import QRCodeCanvas from "qrcode.react";

interface QrCodeLayoutProps {
  establishmentName?: string;
  estId?: number;
  hpFullName?: string;
  espId?: number;
}

const QrCodeLayout: React.FC<QrCodeLayoutProps> = ({
  establishmentName,
  estId,
  hpFullName,
  espId,
}) => {
  return (
    <Box>
      <Box
        sx={{
          width: { xs: "280px", md: "380px", lg: "450px" },
          margin: "20px",
          marginLeft: { sm: "16px", md: "16px" },
          marginTop: "20px",
          border: "2px solid #093170",
          position: "relative",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "50%",
            backgroundColor: "#1976d2",
            position: "absolute",
            zIndex: -1,
            bottom: 0,
            borderTopLeftRadius: "50%",
            borderTopRightRadius: "50%",
          }}
        ></Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
          textAlign={"center"}
        >
          <Typography sx={styles.establishmentName}>
            {establishmentName
              ? establishmentName.toUpperCase()
              : hpFullName?.toUpperCase()}
          </Typography>
          <Typography sx={styles.subText}>is on</Typography>
          <Box sx={styles.cellmaflexLogo}>
            <img
              src={cellmalogo}
              width={"100%"}
              height={"100%"}
              alt="Cellmaflex Logo"
            />
          </Box>
          <Typography sx={styles.scanHereText}>SCAN HERE</Typography>
          <Box
            sx={{
              position: "relative",
              border: "3px solid #093170",
              padding: "15px",
              borderRadius: "20px",
              width: "fit-content",
              backgroundColor: "white",
            }}
          >
            <Box
              sx={{
                width: { xs: "180px", lg: "240px" },
                height: { xs: "180px", lg: "240px" },
              }}
            >
              <QRCodeCanvas
                style={{
                  height: "100%",
                  width: "100%",
                }}
                value={
                  establishmentName
                    ? `${cellmaflexUrl}?estId=${estId}`
                    : `${cellmaflexUrl}?fromQrCodeScan=true&espId=${espId}`
                }
              />
            </Box>
            {/* Image placed at the center */}
            <img
              src={cellmaflexLogo}
              alt="Cellmaflex Logo"
              style={styles.cellmaIcon}
            />
          </Box>

          <Typography sx={styles.mottoText}>SAVE TIME, BOOK ONLINE</Typography>
          <Typography sx={styles.cellmaflexLinkText}>
            or visit: www.cellmaflex.com
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default QrCodeLayout;
const styles = {
  cellmaIcon: {
    position: "absolute" as "absolute", // Define position as "absolute"
    top: "50%",
    left: "50%", //position the image to the center
    transform: "translate(-50%, -50%)",
    zIndex: "1", // Ensure the image is above the QR code
    maxWidth: "80px", // Set a max width to ensure it doesn't interfere with QR code size
    width: "36px", // Specify the width of the image
    height: "36px", // Specify the height of the image
    borderRadius: "50%", //Making the image circular
    boxShadow: "0 0 2px 1px rgba(0, 0, 0, 0.2)", //Adding boxshadow to the Image
    border: "0", //Adding Border to the Image
    outline: "none", //Adding outline to the Image
  },
  cellmaflexLogo: {
    width: { xs: "250px", lg: "380px" },
  },
  qrTextLinks: { textDecoration: "none", color: "#1976D2" },
  establishmentName: {
    fontSize: { xs: "20px", md: "24px", lg: "26px" },
    color: "#093170",
    fontWeight: 550,
    wordBreak: "break-all",
    padding: "10px",
    paddingTop: "16px",
    paddingBottom: "8px",
    textAlign: "center",
    lineHeight: "38px",
  },
  subText: {
    fontSize: { sm: "18px", md: "22px", lg: "24px" },
    color: "#093170",
    fontWeight: 550,
  },
  scanHereText: {
    fontSize: { sm: "18px", md: "20px", lg: "22px" },
    color: "black",
    fontWeight: 550,
    marginBottom: "10px",
  },
  mottoText: {
    fontSize: {
      xs: "18px !important",
      md: "22px !important",
      lg: "28px !important",
    },
    color: "white",
    fontWeight: 550,
  },
  cellmaflexLinkText: {
    fontSize: { xs: "11px", md: "16px", lg: "22px" },
    paddingBottom: "8px",
    color: "white",
  },
};
